import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-15e52125"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deploy-card-title-after" }
const _hoisted_2 = {
  key: 0,
  class: "deploy-card-title-after__muted"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "deploy-card-auth-dot",
  "aria-hidden": "true"
}, "·", -1))
const _hoisted_4 = { class: "deploy-card-auth-end" }
const _hoisted_5 = {
  key: 2,
  class: "deploy-card-title-after__muted"
}
const _hoisted_6 = { class: "deploy-stats" }
const _hoisted_7 = { class: "stat-list" }
const _hoisted_8 = { class: "stat-item el-card" }
const _hoisted_9 = { class: "stat-label" }
const _hoisted_10 = { class: "stat-item el-card" }
const _hoisted_11 = { class: "stat-label" }
const _hoisted_12 = { class: "stat-item el-card" }
const _hoisted_13 = { class: "stat-label" }
const _hoisted_14 = { class: "deploy-actions" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down cm-ui-ml4",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = {
  class: "deploy-download-cascade__primary",
  "aria-label": "platform"
}
const _hoisted_17 = ["onMouseenter", "onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "deploy-download-cascade__label" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-right deploy-download-cascade__arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = {
  class: "deploy-download-cascade__sub",
  role: "region"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_23 = { class: "deploy-download-cascade__sub-scroll" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "deploy-download-cascade__label" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-right deploy-download-cascade__arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "deploy-download-cascade__empty"
}
const _hoisted_29 = {
  key: 1,
  class: "deploy-download-cascade__empty deploy-download-cascade__empty--solo"
}
const _hoisted_30 = {
  class: "cm-align-center",
  style: {"position":"relative","top":"-2px","justify-content":"center"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1777346745741",
  class: "icon cm-ui-mr5",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7949",
  width: "17",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M593.92 92.352c58.816 37.76 146.048 39.232 266.304 90.368A59.776 59.776 0 0 1 896 238.08V604.16c0 93.76-62.912 180.992-164.224 256.064C657.664 915.328 548.48 960 512 960c-36.48 0-129.664-44.672-203.776-99.712C206.912 785.152 128 697.984 128 604.288V237.824a59.648 59.648 0 0 1 35.712-55.04c119.04-50.688 203.2-52.736 264.512-89.408l1.856-1.088c61.76-37.76 105.088-37.76 163.84 0zM345.152 190.72c-7.04 2.048-57.6 16.768-74.048 21.952-25.024 7.936-52.544 16.256-76.864 26.112L192 239.68v368.832c0 62.272 48.768 130.624 138.624 198.144l2.752 2.112c33.088 24.576 88 48.192 123.648 65.536l2.112 1.024c15.552 7.488 29.632 13.44 41.088 17.28l1.28 0.384c3.648 1.216 6.848 2.112 9.472 2.752L512 896h0.192c2.88-0.704 6.592-1.792 11.008-3.2l0.64-0.256 1.536-0.512c11.648-4.032 25.92-10.112 41.6-17.728 35.648-17.344 90.56-40.96 123.648-65.536 90.816-67.52 140.48-135.936 141.376-198.336V239.68l-1.856-0.64c-23.552-9.6-50.56-17.792-75.008-25.472l-3.776-1.216a6139.136 6139.136 0 0 0-74.368-21.76l-2.816-0.832c-44.928-13.44-90.88-25.6-120.96-44.8l-2.176-1.472c-17.92-11.392-29.248-15.36-37.568-15.488h-0.32c-8.96 0-21.888 4.48-42.368 16.896l-0.64 0.448c-31.232 19.072-77.44 31.104-122.944 44.8l-2.048 0.64z m328.96 245.312a32 32 0 0 1-9.472 22.72L506.496 615.04a32 32 0 0 1-44.992 0L378.176 532.48 377.6 532.096a32 32 0 0 1 44.672-45.888l0.448 0.448 61.248 60.544 135.68-133.952a32 32 0 0 1 54.4 22.784z",
    fill: "var(--el-color-primary)",
    "p-id": "7950"
  })
], -1))
const _hoisted_32 = { class: "team-pin-section" }
const _hoisted_33 = { class: "pin-header" }
const _hoisted_34 = { class: "pin-header-label" }
const _hoisted_35 = {
  key: 0,
  class: "pin-item"
}
const _hoisted_36 = { class: "pin-label" }
const _hoisted_37 = { class: "pin-item" }
const _hoisted_38 = { class: "pin-label" }
const _hoisted_39 = { class: "pin-item" }
const _hoisted_40 = { class: "pin-label" }

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { ref, reactive, onMounted, onUnmounted, computed, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useRouter } from 'vue-router'
import Card from '@/views/dashboard/_components/card/card.vue'
import { DeployControlService, DeployStatus } from './service'
import { ApprovalListService } from '@/views/dashboard/approval-center/service'
import { ServiceInfoService } from '@/views/dashboard/home/_components/service-info/service-info.service'
import { Team, TeamInfo } from '@/services/team'
import CodeField from '@/views/dashboard/home/_components/service-info/code-field/code-field.vue'
import AuthDialog from '@/views/dashboard/home/_components/service-info/auth-dialog/auth-dialog.vue'
import { IS_PRIVATE } from '@/common/const/env'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { useRolePermStore } from '@/services/role-perm.service'
import { ClientAliveService, RegularDeploymentItem } from '@/views/dashboard/group/client-alive/client-alive.service'
import {
  DeployOsNavKey,
  DeployDownloadMenuItem,
  getWindowsPackages,
  getWinServerPackages,
  getMacosPackages,
  getLinuxDistroDownloadRows,
} from '@/views/dashboard/group/client-alive/regular-deployment-download-entries'
import { downloadByUrl } from '@/utils/tool'
import { HomeService, AuthorizationResponseData } from '@/views/dashboard/home/home.service'
import { formatTimeStamp } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'deploy-section-card',
  setup(__props) {

const { cmRolePermMapFe } = useRolePermStore()
const { t, locale } = useI18n()

/** 与终端部署页 client-alive 左侧 OS 列表同一套图标 */
const DEPLOY_NAV_ICONS: Record<DeployOsNavKey, string> = {
  windows: getSvgIconDataUrl('views/dashboard/group/client-alive/_images/wind-s'),
  'win-server': getSvgIconDataUrl('views/dashboard/group/client-alive/_images/win-s'),
  macos: getSvgIconDataUrl('views/dashboard/group/client-alive/_images/ios-s'),
  linux: getSvgIconDataUrl('views/dashboard/group/client-alive/_images/linux-s'),
}

const injector = useReflectiveInjector([ApprovalListService, DeployControlService, ServiceInfoService, Team, ClientAliveService, HomeService])
const service = injector.get(DeployControlService)
const serviceInfoService = injector.get(ServiceInfoService)
const teamService = injector.get(Team)
const clientAliveService = injector.get(ClientAliveService)
const homeService = injector.get(HomeService)
const router = useRouter()

const isAuthDialog = ref(false)
const deployStatus = ref<DeployStatus>({
  deployed_count: 0,
  online_count: 0,
  offline_count: 0
})
const teamInfo = reactive<Partial<TeamInfo>>({
  pin_code: '',
  exit_code: '',
  uninstall_code: ''
})
const isCodeShow = ref(false)
let teamInfoSub: { unsubscribe: () => void } | undefined

const permissionAuthLoading = ref(false)
const permissionAuthorization = ref<AuthorizationResponseData | null>(null)

const formattedAuthEndDate = computed(() => {
  const end = permissionAuthorization.value?.authorize_end_time
  if (end == null || Number(end) <= 0) return ''
  return formatTimeStamp(Number(end) * 1000, 'YYYY-MM-DD')
})

const deploySubscriptionAuthStateLabel = computed(() => {
  void locale.value
  const s = permissionAuthorization.value?.authorize_state
  if (s === 0) return t('overviewZone.deploySubscriptionAuthState0')
  if (s === 1) return t('overviewZone.deploySubscriptionAuthState1')
  if (s === 2) return t('overviewZone.deploySubscriptionAuthState2')
  return t('overviewZone.deploySubscriptionAuthStateUnknown')
})

function fetchPermissionOrderAuthorization () {
  // 私有化 & 日本专版展示授权信息
  if (!IS_PRIVATE && !IS_JP_ONLY_BUILD) return
  permissionAuthLoading.value = true
  homeService.getPermissionOrderAuthorization()
    .then((res) => {
      permissionAuthorization.value = res
    })
    .catch(() => {
      permissionAuthorization.value = null
    })
    .finally(() => {
      permissionAuthLoading.value = false
    })
}

const regularDeploymentData = reactive<RegularDeploymentItem>({
  windows_download_url: '',
  win_server_download_url: '',
  windows_xp_download_url: '',
  windows_server2003_download_url: '',
  pin_code: '',
  team_name: '',
  linux_download_map: {},
  systems: [],
  deploy_share_token: '',
  macos_systems: {},
  macos_arm64_download_url: '',
  macos_amd64_download_url: '',
})

const deployDownloadDropdownRef = ref<{ handleClose?: () => void } | null>(null)
const selectedDeployOs = ref<DeployOsNavKey>('windows')
const selectedLinuxTabId = ref('')

const windowsDeployPkgs = computed(() => getWindowsPackages(regularDeploymentData, t))
const serverDeployPkgs = computed(() => getWinServerPackages(regularDeploymentData, t))
const macosDeployPkgs = computed(() => getMacosPackages(regularDeploymentData, t))
const linuxDistroRows = computed(() => getLinuxDistroDownloadRows(regularDeploymentData, t))

/** 侧边栏：仅展示有包的系统（顺序与终端部署一致） */
const downloadNavList = computed(() => {
  const list: Array<{
    key: DeployOsNavKey
    title: string
    icon: string
  }> = []
  if (windowsDeployPkgs.value.length) {
    list.push({
      key: 'windows',
      title: t('terminalDeploy.downloadSidebarWindows'),
      icon: DEPLOY_NAV_ICONS.windows,
    })
  }
  if (!IS_JP_ONLY_BUILD && serverDeployPkgs.value.length) {
    list.push({
      key: 'win-server',
      title: t('terminalDeploy.downloadSidebarWinServer'),
      icon: DEPLOY_NAV_ICONS['win-server'],
    })
  }
  if (!IS_JP_ONLY_BUILD && macosDeployPkgs.value.length) {
    list.push({
      key: 'macos',
      title: t('terminalDeploy.downloadSidebarMacOS'),
      icon: DEPLOY_NAV_ICONS.macos,
    })
  }
  if (!IS_JP_ONLY_BUILD && linuxDistroRows.value.length) {
    list.push({
      key: 'linux',
      title: t('terminalDeploy.downloadSidebarLinux'),
      icon: DEPLOY_NAV_ICONS.linux,
    })
  }
  return list
})

/** 多 Linux 发行版：右侧先列发行版，点选后再列该发行版安装包 */
const linuxCascadeMode = ref<'distro' | 'packages'>('distro')

const currentDeployPackages = computed((): DeployDownloadMenuItem[] => {
  switch (selectedDeployOs.value) {
    case 'windows':
      return windowsDeployPkgs.value
    case 'win-server':
      return serverDeployPkgs.value
    case 'macos':
      return macosDeployPkgs.value
    case 'linux': {
      const row = linuxDistroRows.value.find(r => r.tabId === selectedLinuxTabId.value)
      return row?.items ?? []
    }
    default:
      return []
  }
})

const showLinuxDistroSubpanel = computed(
  () =>
    selectedDeployOs.value === 'linux' &&
    linuxDistroRows.value.length > 1 &&
    linuxCascadeMode.value === 'distro'
)

const linuxSubBackVisible = computed(
  () =>
    selectedDeployOs.value === 'linux' &&
    linuxDistroRows.value.length > 1 &&
    linuxCascadeMode.value === 'packages'
)

function applyPrimaryOs (key: DeployOsNavKey) {
  selectedDeployOs.value = key
  if (key === 'linux' && linuxDistroRows.value.length > 1) {
    linuxCascadeMode.value = 'distro'
    syncLinuxTabSelection()
  } else {
    linuxCascadeMode.value = 'packages'
    if (key === 'linux') syncLinuxTabSelection()
  }
}

function onPickLinuxDistro (tabId: string) {
  selectedLinuxTabId.value = tabId
  linuxCascadeMode.value = 'packages'
}

function onLinuxCascadeBackToDistros () {
  linuxCascadeMode.value = 'distro'
}

function resetDeployCascadeState () {
  linuxCascadeMode.value = 'distro'
}

function syncDeployOsNavSelection() {
  const list = downloadNavList.value
  if (!list.length) {
    return
  }
  if (!list.some(n => n.key === selectedDeployOs.value)) {
    selectedDeployOs.value = list[0].key
  }
}

function syncLinuxTabSelection() {
  const rows = linuxDistroRows.value
  if (selectedDeployOs.value !== 'linux' || !rows.length) {
    return
  }
  if (!rows.some(r => r.tabId === selectedLinuxTabId.value)) {
    selectedLinuxTabId.value = rows[0].tabId
  }
}

watch(downloadNavList, () => syncDeployOsNavSelection(), { immediate: true })
watch([linuxDistroRows, selectedDeployOs], () => syncLinuxTabSelection(), { immediate: true })

function onDeployDownloadVisibleChange (visible: boolean) {
  if (!visible) return
  resetDeployCascadeState()
  void nextTick(() => {
    syncDeployOsNavSelection()
    syncLinuxTabSelection()
  })
}

function handleDeployPackageDownload(url: string) {
  if (!url) return
  downloadByUrl(url)
  deployDownloadDropdownRef.value?.handleClose?.()
}

function loadDeployDownloadData() {
  clientAliveService.fetchDeploymentVersions().then(res => {
    regularDeploymentData.systems = Object.keys(res.linux_download_map || {})
    regularDeploymentData.linux_download_map = res.linux_download_map || {}
    regularDeploymentData.team_name = res.team_name
    regularDeploymentData.pin_code = res.pin_code
    regularDeploymentData.windows_download_url = res.windows_download_url
    regularDeploymentData.win_server_download_url = res.win_server_download_url
    regularDeploymentData.windows_xp_download_url = res.windows_xp_download_url
    regularDeploymentData.windows_server2003_download_url = res.windows_server2003_download_url
    regularDeploymentData.deploy_share_token = res.deploy_share_token
    regularDeploymentData.macos_arm64_download_url = res.macos_arm64_download_url
    regularDeploymentData.macos_amd64_download_url = res.macos_amd64_download_url
    regularDeploymentData.macos_systems = res.macos_systems || {}
  })
}

function loadDeployStatus() {
  service.getDeployStatus().then(res => {
    deployStatus.value = res
  })
}

function loadTeamPinInfo() {
  const currentTeamInfo = teamService.getCurrentTeam()
  Object.assign(teamInfo, {
    pin_code: currentTeamInfo.pin_code || '',
    exit_code: currentTeamInfo.exit_code || '',
    uninstall_code: currentTeamInfo.uninstall_code || ''
  })
}

function handleSaveExitCode(value: string) {
  serviceInfoService.updateExitCode(value).then(() => {
    teamInfo.exit_code = value
    teamService.updateCurrentTeam({
      ...teamService.getCurrentTeam(),
      exit_code: value
    })
    teamService.refreshTeamList()
  })
}

function handleSaveUninstallCode(value: string) {
  serviceInfoService.updateUninstallCode(value).then(() => {
    teamInfo.uninstall_code = value
    teamService.updateCurrentTeam({
      ...teamService.getCurrentTeam(),
      uninstall_code: value
    })
    teamService.refreshTeamList()
  })
}

function handleMoreDeploy() {
  router.push('/dashboard/client-alive')
}

onMounted(() => {
  loadDeployStatus()
  loadTeamPinInfo()
  loadDeployDownloadData()
  fetchPermissionOrderAuthorization()
  teamInfoSub = teamService.currentTeam.subscribe(() => {
    loadTeamPinInfo()
  })
})

onUnmounted(() => {
  teamInfoSub?.unsubscribe()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_role_perm = _resolveDirective("role-perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('overviewZone.deployCardTitle'),
      class: "deploy-section-card-wrap"
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('overviewZone.statDeployedTerminals')), 1),
              _createVNode(_component_router_link, {
                class: "stat-value cm-link",
                to: "/dashboard/client"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(deployStatus.value.deployed_count || 0), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('overviewZone.statOnlineTerminals')), 1),
              _createVNode(_component_router_link, {
                class: "stat-value cm-link",
                to: "/dashboard/client?status=1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(deployStatus.value.online_count || 0), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('overviewZone.statOfflineTerminals')), 1),
              _createVNode(_component_router_link, {
                class: "stat-value cm-link",
                to: "/dashboard/client?status=2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(deployStatus.value.offline_count || 0), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_dropdown, {
              ref_key: "deployDownloadDropdownRef",
              ref: deployDownloadDropdownRef,
              style: {"flex":"1"},
              trigger: "click",
              "hide-on-click": true,
              class: "deploy-download-dropdown",
              "popper-class": "deploy-download-popper",
              onVisibleChange: onDeployDownloadVisibleChange
            }, {
              dropdown: _withCtx(() => [
                _createElementVNode("div", {
                  class: "deploy-download-panel deploy-download-panel--cascade",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (downloadNavList.value.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("nav", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloadNavList.value, (nav) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: nav.key,
                              type: "button",
                              class: _normalizeClass(["deploy-download-cascade__item", { 'is-active': selectedDeployOs.value === nav.key }]),
                              onMouseenter: ($event: any) => (applyPrimaryOs(nav.key)),
                              onClick: ($event: any) => (applyPrimaryOs(nav.key))
                            }, [
                              _createElementVNode("img", {
                                src: nav.icon,
                                class: "deploy-download-cascade__icon",
                                alt: ""
                              }, null, 8, _hoisted_18),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(nav.title), 1),
                              _hoisted_20
                            ], 42, _hoisted_17))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          (linuxSubBackVisible.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "deploy-download-cascade__sub-back",
                                onClick: onLinuxCascadeBackToDistros
                              }, [
                                _hoisted_22,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('overviewZone.deployDownloadBack')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_23, [
                            (showLinuxDistroSubpanel.value)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(linuxDistroRows.value, (row) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: row.tabId,
                                    type: "button",
                                    class: "deploy-download-cascade__item deploy-download-cascade__item--plain",
                                    onClick: ($event: any) => (onPickLinuxDistro(row.tabId))
                                  }, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(row.label), 1),
                                    _hoisted_26
                                  ], 8, _hoisted_24))
                                }), 128))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (currentDeployPackages.value.length)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(currentDeployPackages.value, (pkg, i) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          key: i,
                                          href: "#",
                                          class: "deploy-download-cascade__pkg",
                                          onClick: _withModifiers(($event: any) => (handleDeployPackageDownload(pkg.url)), ["prevent"])
                                        }, _toDisplayString(pkg.label), 9, _hoisted_27))
                                      }), 128))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('terminalDeploy.noPackageAvailable')), 1))
                                ], 64))
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('terminalDeploy.noPackageAvailable')), 1))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  class: "deploy-download-dropdown__trigger"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/overview/_components/approval-deploy-control/_images/download",
                      class: "cm-vertical-middle",
                      color: "#fff",
                      size: 16
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('overviewZone.downloadInstaller')) + " ", 1),
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              class: "cm-ui-ml10",
              plain: "",
              onClick: handleMoreDeploy
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CmSvgIcon, {
                  name: "views/dashboard/overview/_components/approval-deploy-control/_images/share",
                  class: "cm-vertical-middle",
                  size: 16
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('overviewZone.moreDeployMethods')), 1)
              ]),
              _: 1
            }),
            (_unref(IS_PRIVATE))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "primary",
                  plain: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isAuthDialog.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('overviewZone.authInfo')), 1)
                    ])
                  ]),
                  _: 1
                })), [
                  [_directive_role_perm, _unref(cmRolePermMapFe).authorization_upload]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('overviewZone.teamPinAndPasswords')), 1),
            _createElementVNode("div", {
              class: "pin-header-icon",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (isCodeShow.value = !isCodeShow.value))
            }, [
              _createVNode(_component_CmSvgIcon, {
                name: isCodeShow.value
              ? 'views/dashboard/overview/_components/approval-deploy-control/_images/icon-view-close'
              : 'views/dashboard/overview/_components/approval-deploy-control/_images/icon-view-open',
                monochrome: "",
                size: 16
              }, null, 8, ["name"])
            ])
          ]),
          (!_unref(IS_PRIVATE))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('overviewZone.teamPinCode')), 1),
                _createVNode(CodeField, {
                  value: teamInfo.pin_code,
                  "props-show": isCodeShow.value
                }, null, 8, ["value", "props-show"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('overviewZone.exitTerminalPassword')), 1),
            _createVNode(CodeField, {
              value: teamInfo.exit_code,
              "props-show": isCodeShow.value,
              editable: true,
              onBlur: handleSaveExitCode
            }, null, 8, ["value", "props-show"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('overviewZone.exitTeamUninstallPassword')), 1),
            _createVNode(CodeField, {
              value: teamInfo.uninstall_code,
              "props-show": isCodeShow.value,
              editable: true,
              onBlur: handleSaveUninstallCode
            }, null, 8, ["value", "props-show"])
          ])
        ])
      ]),
      _: 2
    }, [
      (_unref(IS_PRIVATE) || _unref(IS_JP_ONLY_BUILD))
        ? {
            name: "titleAfter",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (permissionAuthLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('common.loading')), 1))
                  : (permissionAuthorization.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["deploy-card-auth-state", {
              'is-authed': permissionAuthorization.value.authorize_state === 1,
              'is-expired': permissionAuthorization.value.authorize_state === 2,
              'is-unauth': permissionAuthorization.value.authorize_state === 0,
            }])
                        }, _toDisplayString(deploySubscriptionAuthStateLabel.value), 3),
                        (formattedAuthEndDate.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_3,
                              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('overviewZone.deploySubscriptionAuthEndLabel')) + _toDisplayString(formattedAuthEndDate.value), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('common.noData')), 1))
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title"]),
    (_unref(cmRolePermMapFe).authorization_upload)
      ? (_openBlock(), _createBlock(AuthDialog, {
          key: 0,
          modelValue: isAuthDialog.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isAuthDialog).value = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})